import { gql } from '@apollo/client';

export const GET_SETTINGS__CACHE = gql`
    query Settings{
        Settings @cache{
            id
            _WOT{
            }
        }
    }
`;

export const GET_SETTINGS = gql`
    query getSettings{
        Settings{
            id
            _WOT{
            }
        }
    }
`;

export const UPDATE_SETTINGS = gql`
    mutation updateSettings(
            $moduleId: String!
            $settings: JSONObject!
        ){
            updateSettings(
                moduleId: $moduleId
                settings: $settings
            ){
                _WOT{
                }
            }
        }
`;
